import { WebStorage } from '@backstage/core-app-api';
import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
  scmAuthApiRef,
} from '@backstage/integration-react';
import {
  ApiBlueprint,
  bitbucketAuthApiRef,
  githubAuthApiRef,
  gitlabAuthApiRef,
  microsoftAuthApiRef,
  analyticsApiRef,
  configApiRef,
  identityApiRef,
  storageApiRef,
  errorApiRef, } from '@backstage/frontend-plugin-api';

import { GoogleAnalytics4 } from '@backstage-community/plugin-analytics-module-ga4';

export const scmIntegrationsApi = ApiBlueprint.make({
  name:'scm-integrations',
  params: defineParams => defineParams({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi)
  }),
})

// API to enable auth for the default SCM providers.
// Replaces ScmAuth.createDefaultApiFactory() from old system.
// https://github.com/backstage/backstage/blob/1004d7bd10564abab4d85afffb1ec2184f1367a9/packages/integration-react/src/api/ScmAuth.ts#L93
export const scmAuthApi = ApiBlueprint.make({
  name: 'scm-auth-default',
  params: defineParams => defineParams({
    api: scmAuthApiRef,
    deps: {
      github: githubAuthApiRef,
      gitlab: gitlabAuthApiRef,
      azure: microsoftAuthApiRef,
      bitbucket: bitbucketAuthApiRef,
    },
    factory: ({ github, gitlab, azure, bitbucket }) => ScmAuth.merge(
      ScmAuth.forGithub(github),
      ScmAuth.forGitlab(gitlab),
      ScmAuth.forAzure(azure),
      ScmAuth.forBitbucket(bitbucket),
    ),
  }),
})

// WebStorage API for homepage components
export const storageApi = ApiBlueprint.make({
  name: 'web-storage',
  params: defineParams => defineParams({
    api: storageApiRef,
    deps: { errorApi: errorApiRef },
    factory: ({ errorApi }) => WebStorage.create({ errorApi }),
  }),
})

// Google Analytics API implementation
export const analyticsApi = ApiBlueprint.make({
  name: 'google-analytics',
  params: defineParams => defineParams({
    api: analyticsApiRef,
    deps: { configApi: configApiRef, identityApi: identityApiRef },
    factory: ({ configApi, identityApi }) => GoogleAnalytics4.fromConfig(configApi, { identityApi }),
  }),
})
